import {z} from 'zod';

export const fileListAndCountSchema = z.object({
  new: z.instanceof(File).array(),
  count: z.number().nonnegative(),
});
